export const getToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.jwt_token || null;
  } catch (e) {
    return null;
  }
};
